export default "__VITE_ASSET__B7jVrSk8__"